import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import AudiencePage from './Pages/AudiencePage';
import ContentPage from './Pages/ContentPage';
import FundraisingPage from './Pages/FundraisingPage';
import MarketingPage from './Pages/MarketingPage';
import PartnerMarketingPage from './Pages/PartnerMarketingPage';
import PartnersPage from './Pages/PartnersPage';
import ProjectsPage from './Pages/ProjectsPage';
import ReportingPage from './Pages/ReportingPage';
import SettingsPage from './Pages/SettingsPage';
import PrototypeShell from './Shell/PrototypeShell';

/*
 * IA Overhaul v2 prototype. This is a parallel route — it does not replace
 * production navigation. See ./README.md for context on the design intent.
 */
function IAPrototype(): JSX.Element {
  const match = useRouteMatch<{ accountId: string }>('/:accountId/ia-prototype');
  const base = match?.url ?? '';

  return (
    <PrototypeShell>
      <Switch>
        <Route path={`${base}/marketing/projects`}>
          <ProjectsPage />
        </Route>
        <Route exact={true} path={`${base}/marketing`}>
          <Redirect to={`${base}/marketing/all`} />
        </Route>
        <Route path={`${base}/marketing/:channel`}>
          <MarketingPage />
        </Route>

        <Route exact={true} path={`${base}/content`}>
          <Redirect to={`${base}/content/templates`} />
        </Route>
        <Route path={`${base}/content/:tab`}>
          <ContentPage />
        </Route>

        <Route path={`${base}/partner-marketing/partners`}>
          <PartnersPage />
        </Route>
        <Route path={`${base}/partner-marketing/invites`}>
          <PartnerMarketingPage />
        </Route>
        <Route exact={true} path={`${base}/partner-marketing`}>
          <Redirect to={`${base}/partner-marketing/invites`} />
        </Route>

        <Route exact={true} path={`${base}/fundraising`}>
          <Redirect to={`${base}/fundraising/activity`} />
        </Route>
        <Route path={`${base}/fundraising/:tab`}>
          <FundraisingPage />
        </Route>

        <Route exact={true} path={`${base}/audience`}>
          <Redirect to={`${base}/audience/people`} />
        </Route>
        <Route path={`${base}/audience/:tab`}>
          <AudiencePage />
        </Route>

        <Route path={`${base}/reporting`}>
          <ReportingPage />
        </Route>
        <Route path={`${base}/settings`}>
          <SettingsPage />
        </Route>

        <Redirect to={`${base}/marketing/all`} />
      </Switch>
    </PrototypeShell>
  );
}

export default observer(IAPrototype);
